module.exports = __webpack_public_path__ + "assets/img/ring.643bae50.png";